import { i18n } from 'boot/i18n';
import ViewSessionActivitiesDialog from 'components/SessionActivities/ViewSessionActivitiesDialog.vue';
import { isEmpty } from 'lodash';
import { useQuasar } from 'quasar';
import { useAuth } from 'src/composables/auth';
import { useDialog } from 'src/composables/interactions';
import SessionActivitiesDB from 'src/fb/sessionActivities-db';
import { auth as useAuthStore } from 'src/store/auth';
import { logEvent } from 'src/utils/LogEvent';

// eslint-disable-next-line import/prefer-default-export
export function useSessionActivities() {
  const auth = useAuth();
  const authStore = useAuthStore();
  const { openComponentDialog } = useDialog();
  const $q = useQuasar();

  function openBlockingSessionActivitiesDialog(sessionActivities) {
    openComponentDialog(
      ViewSessionActivitiesDialog,
      {
        sessionActivities,
        title: i18n.t('sessions.modals.sessionActivity.blockingActivities.textTitle'),
        message: i18n.t('sessions.modals.sessionActivity.blockingActivities.textMessage'),
      },
    );
  } // openBlockingSessionActivitiesDialog()

  async function checkUserCanStartSessionActivity(clientId) {
    if (auth.userHasPrivilege('sessionActivities/allowOverlappingActivities')) {
      return true;
    }
    $q.loading.show();

    let sessionActivitiesInProgress = [];
    try {
      const sessionActivitiesDb = new SessionActivitiesDB();
      sessionActivitiesInProgress = await sessionActivitiesDb.readAll([
        ['clinic', '==', authStore.userDetails.clinic],
        ['user', '==', authStore.userDetails.userId],
        ['status', '==', 'in-progress'],
      ]);
    } catch (err) {
      console.error(err);
      logEvent(err);
    } finally {
      $q.loading.hide();
    }

    // Can't start a new staff-only activity if there is an existing session activity in progress
    const blockingSessionActivities = sessionActivitiesInProgress.filter((sessionActivity) => {
      return !sessionActivity.isDeleted && (clientId === null || [clientId, null].includes(sessionActivity.client));
    });

    if (isEmpty(blockingSessionActivities)) {
      return true;
    }

    openBlockingSessionActivitiesDialog(blockingSessionActivities);
    return false;
  } // checkUserCanStartSessionActivity()

  return {
    checkUserCanStartSessionActivity,
  };
}
